import React from 'react';
import SkeletonElement from './SkeletonElement';

import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const SkeletonMainSearch = ({ theme }) => {

    const themeClass = theme || 'light';

    return (
        <div className={`skeleton-wrapper mb-0 ${themeClass}`}>
            <div>
                <Grid container direction="row">
                    <Grid item xs={12} sm={12} md={12}>
                        <Skeleton variant="rect" width="100%" height={40} /> 
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default SkeletonMainSearch;